// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2WXMe","content":"LoadingAlert_content__1nU_M"};